import styled from 'styled-components';

export const PopupMainWrap = styled.div(
    props =>`
        width:100%;
        display: flex;
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,0.3);
        z-index:9;
    `
);

export const PopContentWrap = styled.div(
    props => `
        width:65rem;
        //min-height:60rem;
        //height:60rem;
        max-height:65rem;
        background-color: #fff;
        border-radius:0.8rem;
        display: flex;
        padding:3rem;
        flex-direction: column;
        overflow: auto;
        @media(max-width:1023px){
            width:100%;
            min-height:100vh;
            border-radius: 0;
            padding:2rem;
        }
    `
)